/* ============
 * Organizations State
 * ============
 *
 * The state of the organizations module.
 */

export default {
  all: [],
  pagination: {
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    limit: 20,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/state.js